/**
 * Internal dependencies
 */
import { PREFIX_EVENTS_PRO_STORE } from '@moderntribe/events-pro/data/prefix';

export const SET_RELATED_EVENTS_INITIAL_STATE = `${ PREFIX_EVENTS_PRO_STORE }/SET_RELATED_EVENTS_INITIAL_STATE`;

export const SET_RELATED_EVENTS_TITLE = `${ PREFIX_EVENTS_PRO_STORE }/SET_RELATED_EVENTS_TITLE`;

export const SET_RELATED_EVENTS_DISPLAY_IMAGES = `${ PREFIX_EVENTS_PRO_STORE }/SET_RELATED_EVENTS_DISPLAY_IMAGES`;
